import Vue from "vue";
import axios from "axios";
import store from "../store";

import { loadProgressBar } from "axios-progress-bar";

const instance = axios.create({
    baseURL: window.location.origin.startsWith("http://localhost")
        ? "https://localhost:44307"
        : window.location.origin,
});

function errorHandler(error) {
    if (error.response && error.response.status == 401) {
        window.location.href = "/login";

        return;
    }

    console.log(error);

    const text =
        error.response.data && error.response.data.Message
            ? error.response.data.Message
            : "An error has occurred";

    Vue.notify({
        group: "notification",
        text: text,
        type: "error",
    });

    throw new Error(text);
}
instance.interceptors.request.use(function(config) {
    config.headers.Authorization = store.state.authentication.token;

    return config;
});
instance.interceptors.response.use((response) => {
    return response ? response.data : response;
}, errorHandler);

loadProgressBar(null, instance);

Vue.prototype.$http = instance;
